import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login.vue'
import Home from '@/components/Home.vue'
import Transaction from '@/components/Transaction/Transaction.vue'
import OTC from '@/components/OTC/OTC.vue'
import Personal from '@/components/Personal/Personal.vue'
import T_Details from '@/components/Transaction/Details/T_Details.vue'
import Order from '@/components/Order/Order.vue'
import ExtractHome from '@/components/Extract/ExtractHome.vue'
import Deposit from '@/components/Extract/Deposit/Deposit.vue'
import Withdraw from '@/components/Extract/Withdraw/Withdraw.vue'

import PC from '@/components/PC/PC.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/PC',
      name: 'PC',
      component: PC,
      mete:{title: 'Local Bitcoin'}
    },
    {
      path: '/M',
      name: 'Login',
      component: Login,
      mete:{title: 'Local Bitcoin'}
    },
    {
      path: '/M/Home',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Local Bitcoin',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/Transaction',
      name: 'Transaction',
      component: Transaction,
      meta: {
        title: 'Local Bitcoin',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/OTC',
      name: 'OTC',
      component: OTC,
      meta: {
        title: 'Local Bitcoin',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/Personal',
      name: 'Personal',
      component: Personal,
      meta: {
        title: 'Local Bitcoin',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/T_Details',
      name: 'T_Details',
      component: T_Details,
      meta: {
        title: 'TransactionDetails',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/Order',
      name: 'Order',
      component: Order,
      meta: {
        title: 'Order record',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/ExtractHome',
      name: 'ExtractHome',
      component: ExtractHome,
      meta: {
        title: 'Extract',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/Deposit',
      name: 'Deposit',
      component: Deposit,
      meta: {
        title: 'Deposit',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    },
    {
      path: '/M/Withdraw',
      name: 'Withdraw',
      component: Withdraw,
      meta: {
        title: 'Withdraw',
        requireAuth: true, // 2021-11-03:判断是否需要登录
        }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/OK_Scott/router/index.js